import React from "react";

export const ACCENT = "#FBBF24";

export const STAGE_COLOR = {
  "0":  "#4ADE80",
  "I":  "#4ADE80",
  "II": "#FBBF24",
  "III":"#FB923C",
  "IV": "#F87171",
  "Unknown": "#A3ACA7",
};
export const RESPONSE_COLOR = {
  "CR": "#4ADE80",
  "PR": "#4ADE80",
  "SD": "#FBBF24",
  "PD": "#F87171",
  "Baseline": "#60A5FA",
};
export const ECOG_COLOR = {
  0: "#4ADE80", 1: "#4ADE80", 2: "#FBBF24",
  3: "#FB923C", 4: "#F87171", 5: "#DC2626",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(); } catch { return iso; }
}
export function humanize(v) {
  return String(v || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-wider text-[#A3ACA7] mb-1">{label}</div>
      {children}
    </label>
  );
}

export function Checkbox({ label, checked, onChange, testId }) {
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer text-white" data-testid={testId}>
      <input type="checkbox" checked={!!checked}
             onChange={(e) => onChange(e.target.checked)}
             className="accent-[#FBBF24]" />
      {label}
    </label>
  );
}

export function SummaryCard({ title, value, icon: Icon, colored }) {
  return (
    <div className="ros-card">
      <div className="flex items-center gap-2 ros-label"><Icon size={12} /> {title}</div>
      <div className="mt-2 text-3xl font-heading font-bold"
           style={{ color: colored || "#fff" }}>{value}</div>
    </div>
  );
}

export function HistoryTable({ title, testId, rows, rowTestId, empty, columns }) {
  return (
    <div className="ros-card" data-testid={testId}>
      <div className="font-heading text-lg mb-3">{title}</div>
      {rows.length === 0 ? (
        <div className="text-sm text-[#A3ACA7]">{empty}</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[11px] text-[#A3ACA7] uppercase tracking-wider">
                {columns.map((c) => <th key={c.label} className="py-2 pr-4">{c.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-[#272E2B]" data-testid={rowTestId(r)}>
                  {columns.map((c) => (
                    <td key={c.label} className="py-2 pr-4 text-white">{c.render(r)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
